import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

export const getEmailReportState = (state: NutshellState) => state.reports.email;

/**
 * Detail tab selectors
 */
export const getDetailState = createSelector([getEmailReportState], (emailReportState) => {
    return emailReportState.detail;
});

export const getDetailIsLoading = createSelector([getDetailState], (detailState) => {
    return detailState.isLoading;
});

export const getDetailHasError = createSelector([getDetailState], (detailState) => {
    return detailState.hasError;
});

export const getDetailContent = createSelector([getDetailState], (detailState) => {
    return detailState.data;
});

export const getDetailNumPages = createSelector([getDetailState], (detailState) => {
    return detailState.numPages ? detailState.numPages : 1;
});

/**
 * Summary selectors
 */
export const getSummaryState = createSelector([getEmailReportState], (emailReportState) => {
    return emailReportState.summary;
});

export const getSummaryIsLoading = createSelector([getSummaryState], (summaryState) => {
    return summaryState.isLoading;
});

export const getSummaryHasError = createSelector([getSummaryState], (summaryState) => {
    return summaryState.hasError;
});

export const getSummaryData = createSelector([getSummaryState], (summaryState) => {
    return summaryState.data;
});

export const getSummaryTotals = createSelector([getSummaryState], (summaryState) => {
    return summaryState.totals;
});

/**
 * leadOutcomes
 */

export const getLeadOutcomes = (state: NutshellState) => getEmailReportState(state).leadOutcomes;
